import { render, staticRenderFns } from "./GdvFehlermeldungen.vue?vue&type=template&id=0be3ba94&"
import script from "./GdvFehlermeldungen.vue?vue&type=script&lang=js&"
export * from "./GdvFehlermeldungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports